import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { AjudaRotina } from 'src/app/models/ajuda-rotina';
import { AbstractService } from 'src/app/services/abstract.service';
import { AjudaRotinaService } from 'src/app/services/ajuda-rotina.service';
import { GenericCadastro } from 'src/app/utilities/generic-cadastro';
import { clone } from 'src/app/utilities/util/clone-utils';
import { FormValidation } from 'src/app/utilities/util/form-validation';

@Component({
  selector: 'habil-cadastro-ajuda-rotina',
  templateUrl: './cadastro-ajuda-rotina.component.html',
  styleUrls: ['./cadastro-ajuda-rotina.component.scss'],
  providers: [MessageService, DialogService],
})
export class CadastroAjudaRotinaComponent
  extends GenericCadastro<AjudaRotina, AjudaRotinaService>
  implements OnInit
{
  newObject(): AjudaRotina {
    const obj: AjudaRotina = new AjudaRotina();
    obj.id = 0;
    obj.deleted = false;
    obj.publicado = true;
    obj.editadoNaCentral = false;
    return obj;
  }

  /** Ações da tela, que vêm do backend como JSON em texto. */
  get acoes(): string[] {
    return this.listaDeJson(this.obj?.acoes).map((a) => String(a));
  }

  /** Rotinas relacionadas, para o editor saber para onde a ajuda pode apontar. */
  get relacionadas(): { nome: string; rota: string }[] {
    return this.listaDeJson(this.obj?.relacionadas);
  }

  private listaDeJson(valor: string): any[] {
    if (!valor) {
      return [];
    }
    try {
      const lista = JSON.parse(valor);
      return Array.isArray(lista) ? lista : [];
    } catch {
      // campo vem do importador; se vier quebrado, a tela continua utilizável
      return [];
    }
  }

  doValidate(): boolean {
    const validation: FormValidation = new FormValidation();
    validation.toValidate = [
      {
        condition: !!this.obj.resumo && this.obj.resumo.trim().length > 0,
        message: 'O resumo é obrigatório — é a frase que o usuário lê primeiro.',
      },
    ];
    if (!validation.isValid()) {
      validation.message().forEach((m) => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: m });
      });
    }
    return validation.isValid();
  }

  constructor(
    public service: AjudaRotinaService,
    public messageService: MessageService,
    public dialogService: DialogService,
    public route: ActivatedRoute,
    public router: Router,
    public confirmationService: ConfirmationService,
    public titleService: Title,
    public breadcrumbService: BreadcrumbService
  ) {
    super();
    this.breadcrumbService.setItems([
      { label: 'Ajuda das rotinas', routerLink: '/adm/ajuda-rotinas' },
      { label: 'Edição' },
    ]);
  }

  ngOnInit(): void {
    if (this._isDialog) {
      this._loading = true;
      if (this._externalObj != null && this._externalObj != undefined) {
        this.obj = clone(this._externalObj);
        this.id = this.obj.id;
        this.idCampos = this.id == undefined ? '0' : this.id.toString();
      } else {
        this.obj = this.newObject();
        this.idCampos = this.id == undefined ? '0' : this.id.toString();
        this.loadAuxObjects();
      }
      this._loading = false;
    } else {
      this.titleService.setTitle('Ajuda das rotinas - ' + AbstractService.app);
      super.ngOnInit();
    }
  }

  doBeforeSave() {}
}
